import {extractErrorToString} from './api'

export function showApiError (elem, e, fallbackMessage) {
  if (!elem || !elem.$snotify) {
    console.log(e)
    return
  }

  elem.$snotify.error(extractErrorToString(e, fallbackMessage), {
    showProgressBar: false
  })
}



// WEBPACK FOOTER //
// ./src/helpers/notification.js